export const useNavHover = nav => {
  const getHoverStart = hoverId => nav.findIndex(({ id }) => id === hoverId) + 1
  const getHoverEnd = hoverId => {
    const startIndex = getHoverStart(hoverId)

    for (let i = startIndex; i < nav.length; i++) {
      if (
        nav[i].__typename === 'CraftContent_navigation_rootLevelLink_BlockType'
      ) {
        return i
      }
    }
  }

  return { getHoverStart, getHoverEnd }
}
